import { render, staticRenderFns } from "./PartyPolicies.vue?vue&type=template&id=437aa800"
import script from "./PartyPolicies.vue?vue&type=script&lang=js"
export * from "./PartyPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports